import React from 'react'

function BotonOpcionesAdmin({ setTabla,opcion,texto}) {
  return (
    <button
    className="w-full h-16 py-2 px-3 text-xl bg-AzulF text-GrisClaro font-bold rounded hover:bg-Blanco hover:text-AzulF hover:border hover:border-AzulF"
    onClick={() => setTabla(opcion)}
  >
    {texto}
  </button>
  )
}

export default BotonOpcionesAdmin